namespace Cryptomathic.Crypto {

  export enum SignatureRequestType {
    PSS = 1,
    PKCS1 = 2
  }

}
